export default "__VITE_PUBLIC_ASSET__b5ba3d6d__"